// from https://stackoverflow.com/questions/196972/convert-string-to-title-case-with-javascript
export function toTitleCase(str) {
    return str.replace(/\./g, " ").replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    })
}

export const getInitials = name => {
    return name[0].toString().toUpperCase()
}

export const getDisplayName = (name, alternative) => {
    return name || alternative
}



// WEBPACK FOOTER //
// ./src/util/name_utils.js